async function renderReceiptImage(node: HTMLElement) {
  await document.fonts.ready
  await Promise.all(Array.from(node.querySelectorAll('img')).map((img) => img.decode()))
  const { toBlob } = await import('html-to-image')
  const blob = await toBlob(node, {
    pixelRatio: 2,
    backgroundColor: '#ffffff',
    includeQueryParams: true,
    // mx-auto 的计算值会被克隆为实际外边距；独立图片需从原点绘制，否则右侧会被裁切。
    // 同时清除 Tailwind v4 的逻辑外边距，仅修改导出副本，不影响页面居中。
    style: { margin: '0', marginInline: '0', marginBlock: '0' }
  })
  if (!blob) {
    throw new Error('无法生成收据图片，请重试')
  }
  return blob
}

export async function copyReceiptImage(node: HTMLElement) {
  if (
    !('clipboard' in navigator) ||
    typeof navigator.clipboard.write !== 'function' ||
    typeof ClipboardItem === 'undefined'
  ) {
    throw new Error('当前浏览器不支持复制图片，请使用支持剪贴板的浏览器并通过 HTTPS 或 localhost 访问')
  }
  // 在点击时立即发起写入，图片 Promise 交给 ClipboardItem，避免异步渲染丢失用户激活状态。
  const image = renderReceiptImage(node)
  const write = navigator.clipboard.write([new ClipboardItem({ 'image/png': image })])
  await Promise.all([image, write])
}
